import { 
  Scissors, 
  GitBranch, 
  Layers, 
  Pill, 
  Crown, 
  Target, 
  Wrench, 
  Stethoscope, 
  Baby, 
  Users 
} from "lucide-react";

const iconMap = {
  Scissors,
  GitBranch,
  Layers,
  Pill,
  Crown,
  Target,
  Wrench,
  Stethoscope,
  Baby,
  Users
};

const SubjectCard = ({ subject, stats, onClick, large = false }) => {
  const IconComponent = iconMap[subject.icon] || Target;
  const accuracy = stats?.accuracy || 0;
  const answered = stats?.answered || 0;

  return (
    <button
      onClick={onClick}
      data-testid={`subject-${subject.id}`}
      className={`subject-card glass rounded-xl border border-border text-left transition-all hover:border-border hover-lift
        ${large ? 'p-6' : 'p-4'}
      `}
    >
      <div className="flex items-start gap-3">
        <div 
          className={`rounded-lg flex items-center justify-center flex-shrink-0
            ${large ? 'w-12 h-12' : 'w-10 h-10'}
          `}
          style={{ backgroundColor: `${subject.color}20` }}
        >
          <IconComponent 
            className={large ? 'w-6 h-6' : 'w-5 h-5'} 
            style={{ color: subject.color }} 
          />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`font-medium truncate ${large ? 'text-base' : 'text-sm'}`}>
            {subject.name}
          </p>
          {answered > 0 ? (
            <div className="flex items-center gap-2 mt-1">
              <div className="flex-1 h-1.5 rounded-full bg-secondary overflow-hidden">
                <div 
                  className="h-full rounded-full transition-all progress-animate"
                  style={{ 
                    width: `${accuracy}%`,
                    backgroundColor: accuracy >= 70 ? '#84CC16' : accuracy >= 50 ? '#F59E0B' : '#E11D48'
                  }}
                />
              </div>
              <span className={`text-xs font-medium ${
                accuracy >= 70 ? 'text-success' : 
                accuracy >= 50 ? 'text-warning' : 
                'text-destructive'
              }`}>
                {accuracy}%
              </span>
            </div>
          ) : (
            <p className="text-xs text-muted-foreground mt-1">Not started</p>
          )}
          {large && answered > 0 && (
            <p className="text-xs text-muted-foreground mt-1">
              {stats.correct}/{answered} correct
            </p>
          )}
        </div>
      </div>
    </button>
  );
};

export default SubjectCard;
